import {connect} from "react-redux";
import RmList from "./RmList";
import {bindActionCreators} from "redux";
import {getLead, getLeadFilter} from "../../../../service/Lead/action";
import { getjuniorListingForHod, saveRatingForHod, emailDropdownData, getRmViewDetails, ratingSave } from "../../../../service/Dealer/action";
import { activityList } from "../../../../service/Activity/action";


const mapStateToProps = (state) => ({
    leadList:state.Lead.leadList,
    leadFilter:state.Lead.leadFilter,
    juniorListHod:state.Dealer.juniorListHod,
    ratingByHod: state.Dealer.ratingByHod,
    getEmailDropdown: state.Dealer.getEmailDropdown,
    getRmDetails: state.Dealer.getRmDetails,
    savedRating: state.Dealer.savedRating,
    activityListDetails: state.Activity.activityList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getLead,
            getLeadFilter,
            getjuniorListingForHod,
            saveRatingForHod,
            emailDropdownData,
            getRmViewDetails,
            ratingSave,
            activityList
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RmList);
